import {RemoteCompanyPortal} from 'data/usecases/public/sign-in/get-company-portal';
import {CompanyPortal} from 'domain/usecases/public/sign-in/company-portal';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {B2BEndPoints} from 'main/factories/usecases/endpoints';

export const makeRemoteGetCompanyPortal = (): CompanyPortal =>
	new RemoteCompanyPortal(
		makeBFFApiUrl(B2BEndPoints.companyPortal),
		makeAuthorizeHttpClientDecorator(),
	);
